import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import routes from "../../../../Helpers/Routes.json";
import { Context } from "../../../../Shared/Context/GlobalContext";

export let paymentInterval = null;

export const ProcessingPaymentComponent = ({
  transaction,
  setError,
  setTransaction,
}) => {
  const navigate = useNavigate();
  const { resetCart } = useContext(Context);

  async function processPaymentInterval(transaction) {
    paymentInterval = setTimeout(async () => {
      var response = await fetch(
        process.env.REACT_APP_API_HOST + `/api/payment/${transaction}/status`
      );

      if (response.status === 200) {
        clearTimeout(paymentInterval);
        const { data } = await response.json();
        const status = (data.status || "").toLowerCase();

        if (status === "paid" || status === "completed" || status === "success") {
          resetCart();
          navigate(
            routes.Payment.success.replace(":transaction", data.order)
          );
          return;
        }

        if (status === "error" || status === "refunded" || status === "declined" || status === "cancelled") {
          setError(data.message || "Payment was not successful");
          setTransaction(null);
          return;
        }
      }
      await processPaymentInterval(transaction);
    }, 2000);
  }

  useEffect(() => {
    processPaymentInterval(transaction);
    return () => {
      clearTimeout(paymentInterval);
    };
  }, []);
  return null;
};
